import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryCataloguePropsBody,
  IInventoryProductListGeneralDetailsCreateResponse,
} from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export type RotaCreationReturnType = {
  status: boolean;
  message: string;
};

export const useInventoryProductCatalogueUpdateAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (filterParams: IInventoryCataloguePropsBody, productId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: RotaCreationReturnType = await axios
          .put(`${INVENTORY_MODULE?.PRODUCT_UPDATE_API?.baseURL}${productId}/`, filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryProductListGeneralDetailsCreateResponse>) => {
            if (res.data.status === true) {
              toast.success("Catalogue has been updated ");
              return { status: true, message: "Updated" };
              //IF COND
            } else {
              //ELSE COND
              return { status: false, message: "Manufacturere Updation Faield" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "Manufacturere Updation Faield" };
          });
        return response;
      } catch (e: any) {
        const vv = e.response.data as any;
        toast.error("Server Error: " + e.message);
        return { status: false, message: vv.message };
      }
    },
    [dispatch],
  );
  return execute;
};
